import { z } from 'zod';
/** The six venues of the compound. PRD §5. */
export const GAME_IDS = ['dama', 'tongits', 'pusoydos', 'pusoy', 'mahjong', 'gera'];
export const GameId = z.enum(GAME_IDS);
/** PRD §7.2. */
export const STAKE_TIERS = ['barya', 'bente', 'datu'];
export const StakeTier = z.enum(STAKE_TIERS);
/**
 * Chips are integers. There is deliberately no decimal, no currency code and
 * no formatter that emits a currency symbol anywhere in this codebase —
 * design spec §2, PRD §7.3.
 */
export const Chips = z.number().int().nonnegative();
export const VENUES = {
    dama: {
        id: 'dama',
        name: 'Dama',
        station: 'Ang bangketa',
        tagline: 'Tansan sa plywood, ilaw ng poste.',
        seats: [2],
        turnMs: 20_000,
        wave: 1,
    },
    tongits: {
        id: 'tongits',
        name: 'Tongits',
        station: 'Bangko sa tindahan',
        tagline: 'Tatlo lang tayo. Sapaw agad.',
        seats: [3],
        turnMs: 15_000,
        wave: 1,
    },
    pusoydos: {
        id: 'pusoydos',
        name: 'Pusoy Dos',
        station: 'Ang garahe',
        tagline: 'Hawak mo ba ang mesa?',
        seats: [4],
        turnMs: 15_000,
        wave: 1,
    },
    mahjong: {
        id: 'mahjong',
        name: 'Mahjong',
        station: 'Ang karport',
        tagline: 'Labing-anim na tile. Seryosong mesa.',
        seats: [4],
        turnMs: 25_000,
        wave: 2,
    },
    pusoy: {
        id: 'pusoy',
        name: 'Pusoy',
        station: 'Ang balkonahe',
        tagline: 'Tatlong hanay. Isipin mo muna.',
        seats: [2, 3, 4],
        turnMs: 60_000,
        wave: 3,
    },
    gera: {
        id: 'gera',
        name: 'Gera',
        station: 'Outpost ng barangay',
        tagline: 'Walang nakakaalam ng ranggo mo.',
        seats: [2],
        turnMs: 30_000,
        wave: 3,
    },
};
export const STAKES = {
    barya: { id: 'barya', name: 'Barya', minBuyIn: 1_000, maxBuyIn: 2_000, tongBps: 500, kuboAllowed: true },
    bente: { id: 'bente', name: 'Bente', minBuyIn: 10_000, maxBuyIn: 20_000, tongBps: 500, kuboAllowed: true },
    datu: { id: 'datu', name: 'Datu', minBuyIn: 100_000, maxBuyIn: 250_000, tongBps: 500, kuboAllowed: false },
};
/** PRD §7.1 faucets. All values TUNE at soft launch. */
export const ECONOMY = {
    starterRack: 25_000,
    baonBase: 1_000,
    /** 7-day streak ladder, index 0 = day 1. */
    baonLadder: [1_000, 1_150, 1_350, 1_600, 1_900, 2_200, 2_500],
    rescueAmount: 200,
    rescueThreshold: 500,
    rescueDailyCap: 3,
    /** Reconnect grace — PRD §8. */
    reconnectGraceMs: 60_000,
};
export const CHIP_PACKS = [
    { productId: 'tpm.chips.12k', chips: 12_000, pricePhp: 49, bestValue: false },
    { productId: 'tpm.chips.40k', chips: 40_000, pricePhp: 149, bestValue: true },
    { productId: 'tpm.chips.150k', chips: 150_000, pricePhp: 499, bestValue: false },
    { productId: 'tpm.chips.550k', chips: 550_000, pricePhp: 1_490, bestValue: false },
];
/** Table talk — presets only, no free text at v1. Design spec §11. */
export const TABLE_TALK = [
    { id: 'sige', text: 'Sige pa!' },
    { id: 'hina', text: 'Hina naman' },
    { id: 'dali', text: 'Dali na' },
    { id: 'aray', text: 'Aray' },
    { id: 'suwerte', text: 'Suwerte lang ’yan' },
    { id: 'bawi', text: 'Bawi ako' },
    { id: 'todas', text: 'Todas ka na' },
    { id: 'isapa', text: 'Isa pa!' },
    { id: 'gera', text: 'Ge, gera' },
    { id: 'galing', text: 'Galing ah' },
    { id: 'miron', text: 'Miron ka lang' },
    { id: 'salamat', text: 'Salamat sa chips 😏' },
];
export const TableTalkId = z.enum(TABLE_TALK.map((t) => t.id));
/**
 * The disclosure that must appear on the store screen, the buy-in sheet and
 * settings. Design spec §13 — one string, so it can never drift between
 * surfaces.
 */
export const NO_CASH_VALUE_DISCLOSURE = 'Chips have no cash value and cannot be cashed out, sold, or transferred.';
export const NO_CASH_VALUE_DISCLOSURE_TL = 'Walang cash value ang chips at hindi pwedeng i-cash out, ibenta, o ilipat.';
//# sourceMappingURL=domain.js.map